module.exports = __webpack_public_path__ + "static/Slide02@2x.1fd987be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide02@2x.png
// module id = 706
// module chunks = 216210090109534